// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","logo":"Footer_logo__w79hm","text":"Footer_text__LFzxy","box":"Footer_box__dEhGI","copy":"Footer_copy__NeIYV"};